"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../constants/index.js");
var getAdobeLaunch = function getAdobeLaunch(adobeLaunch) {
  if (!adobeLaunch) {
    return {
      env: 'staging',
      property: _index.brandValues.properties.TELUS
    };
  }
  var env = adobeLaunch.env,
    property = adobeLaunch.property;
  return {
    env: env === 'production' ? 'production' : 'staging',
    property: Object.values(_index.brandValues.properties).includes(property) ? property : _index.brandValues.properties.TELUS
  };
};
var _default = exports["default"] = getAdobeLaunch;